module.exports = __webpack_public_path__ + "img/home_05.a850408d.png";